export class RecipientFilterCriteria {
  company: string;
  recipientName: string;
  email: string;

  constructor(company: string, recipientName: string, email: string) {
    this.company = company;
    this.recipientName = recipientName;
    this.email = email;
  }

}
